import { useEffect } from 'react';
import { useForceBack } from './useForceBack';

export const useRedirect = (shouldRedirect = false, path?: string) => {
  const { forceBack, goBack } = useForceBack(path);

  useEffect(() => {
    if (shouldRedirect) goBack(forceBack);
  }, [shouldRedirect, forceBack, goBack]);
};
